<template>
	<div class="container-payments mt-5">
    <template v-if="(havePac && checkFintoc) || (showFintoc && checkFintoc)">
        <div class="text-right">
          <b-button v-if="!havePac " variant="outline-dark" @click="showFintoc = false">Volver</b-button>
        </div>
        <pacFintoc :asset_id="asset_id" :project_id="project_id" :key="'fin'+asset_id" :response_pac="responsePac" />
    </template>
    <template v-else-if="(haveCards && checkOneClick) || (showOneClick && checkOneClick)">
        <div class="text-right">
          <b-button v-if="!haveCards " variant="outline-dark" @click="showOneClick = false">Volver</b-button>
        </div>
        <oneclick v-if="checkOneClick" :asset_id="asset_id" :project_id="project_id" :key="'one'+asset_id" />
    </template>
    <template v-else>
      <b-row style="width: 100%;" class="content-card" no-gutters>
        <b-col md="7" class="px-0 text-center">
          <h3 class="text-customer">¡Olvidate de pagar tus cuotas aprovechando el pago automático!</h3>
          <b-card-img :src="require('@/assets/images/working.png')" alt="Image" class="rounded-0 my-4" style="width: 70%"></b-card-img>
          <h5>Utiliza tu {{ checkFintoc ? 'cuenta corriente' : '' }} {{ checkFintoc && checkOneClick ? 'o' : '' }} {{ checkOneClick ? 'tarjeta de crédito' : '' }} y olvidate de tener que pagar tus cuotas mes a mes.</h5>
        </b-col>
        <b-col class="px-0">
          <b-card v-if="checkFintoc" no-body class="overflow-hidden p-4 select-card special" @click="showFintoc = true">
            <b-row no-gutters>
              <b-col md="5">
                <b-card-img :src="require('@/assets/images/account.png')" alt="Image" class="rounded-0" style="opacity: .9"></b-card-img>
              </b-col>
              <b-col md="7">
                <b-card-body title="Cuenta corriente" align="center">
                  <b-card-text>
                    <div class="text-center">
                      Aprovecha el pago automático de tus cuotas con tu cuenta corriente.
                    </div>
                    <div class="pt-5 text-center">
                      <b-button variant="customer" size="lg" @click="showFintoc = true">Agregar PAC</b-button>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
          <b-card v-if="checkOneClick" no-body class="overflow-hidden mt-4 p-4 select-card" style="max-width: 540px;" @click="showOneClick = true">
            <b-row no-gutters>
              <b-col md="5">
                <b-card-img :src="require('@/assets/images/card.png')" alt="Image" class="rounded-0" style="opacity: .9"></b-card-img>
              </b-col>
              <b-col md="7">
                <b-card-body title="Tarjeta de crédito" align="center">
                  <b-card-text>
                    <div class="text-center">
                      Configura el pago por tu tarjeta de crédito.
                    </div>
                    <div class="pt-4 text-center">
                      <b-button variant="customer" size="lg" @click="showOneClick = true">Agregar PAT</b-button>
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </template>
	</div>
</template>
<script>
  import oneclick from "../oneclick/Oneclick";
  import pacFintoc from "./pacs/PacFintoc";

	export default {
		name: "paymentOptions",
		components: {
      oneclick, pacFintoc
		},
		props: {
			asset_id: null,
			project_id: {default: null}
		},
		data() {
			return {
        havePac: null,
        showFintoc: false,
        showOneClick: false
			}
		},
    mounted(){
      this.checkPac()
    },
    computed: {
      contract_id(){
				return this.$store.getters.getContractId == undefined ? null : this.$store.getters.getContractId
			},
			haveCards(){
        if(this.$store.getters.getCards){
          return this.$store.getters.getCards.length > 0 ? true : false;
        }else{
          return false
        }
			},
      checkFintoc(){
        if(this.$store.getters.getCustomerData){
          return this.$store.getters.getCustomerData.products.find( product => product.name == "Fintoc") ? true : false;
        }else{
          return false;
        }
      },
      checkOneClick(){
        if(this.$store.getters.getCustomerData){
          return this.$store.getters.getCustomerData.products.find( product => product.name == "Pago One Click") ? true : false;
        }else{
          return false;
        }
      },
    },
		methods: {
      checkPac(){
        let self = this;
        this.axios.get(`payments/get_fintoc_pacs?contract_id=${this.contract_id}`).then(result => {
          self.havePac = result.data ? true : false;
          self.responsePac = result.data;
          if(result.data)
            this.$store.commit("setAutomatedPayments", true);
        }).catch(error => {
          console.log(error)
        })
      },
      parseDate(date){
        return this.$moment(date).format("DD-MM-YYYY")
      },
		},
    watch: {
      contract_id: function (new_val) {
        if (new_val)
          this.checkPac()
      }
    }
	};
</script>
<style scoped>
.margin-10 {
	margin-top:10
}
</style>
